import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import SEO from "../../components/SEO";
import IntroHeader from "../../components/IntroHeader";
import { Container, Section } from "../../components/LayoutUtils";
import Layout from "../../layouts/index";
import getPageImage from "../../utils/getPageImage";
import GalleryItemList from "../../components/GalleryItemList";

const GalleryPage = ({ data, pageContext }) => {
  const page = data.contentfulPage;
  const { id: selected } = pageContext;
  return (
    <Layout>
      <SEO
        image={getPageImage(page)}
        title="Gallery"
        description="Pictures of our favourite handmade suits, coats and jackets"
      />
      <IntroHeader {...page} />
      <Container>
        <Section>
          <GalleryItemList selected={selected} />
        </Section>
      </Container>
    </Layout>
  );
};

GalleryPage.propTypes = {
  pageContext: PropTypes.shape({}).isRequired,
  data: PropTypes.shape({
    contentfulPage: PropTypes.shape({})
  }).isRequired
};

export const query = graphql`
  query {
    contentfulPage(slug: { eq: "gallery" }) {
      ...page
    }
  }
`;

export default GalleryPage;
